import { render, staticRenderFns } from "./publicProp.vue?vue&type=template&id=3e5f3170&scoped=true&"
import script from "./publicProp.vue?vue&type=script&lang=ts&"
export * from "./publicProp.vue?vue&type=script&lang=ts&"
import style0 from "./publicProp.vue?vue&type=style&index=0&id=3e5f3170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5f3170",
  null
  
)

export default component.exports